/**
 * CloudHydrationCompleted.contract.ts — OPERATOR IDENTITY™ Phase 3 (Build 2.08.0).
 * Published by the Hydration Orchestrator once every module in the
 * deterministic restore pipeline has finished (restored, no-data, skipped,
 * or failed). Failures never stop the pipeline, so this event ALWAYS fires.
 */

import type { EventContract } from '../EventContractRegistry';

export const CloudHydrationCompletedContract: EventContract = {
  name: 'CloudHydrationCompleted',
  version: 1,
  description: 'Published when the full cloud-restore pipeline completes (all modules attempted).',
  publishers: ['hydration-orchestrator'],
  subscribers: [],
  fields: [
    { name: 'restored',   type: 'number', required: true, description: 'Modules that adopted a newer cloud copy' },
    { name: 'failed',     type: 'number', required: true, description: 'Modules whose hydration threw' },
    { name: 'skipped',    type: 'number', required: true, description: 'Local-only modules (no cloud persistence)' },
    { name: 'noData',     type: 'number', required: true, description: 'Modules with no newer cloud copy' },
    { name: 'durationMs', type: 'number', required: true, description: 'Total pipeline duration in milliseconds' },
    { name: 'source',     type: 'string', required: true, description: 'Restore source: cloud, local, or offline' },
  ],
  allowExtraFields: false,
  timestampPolicy: 'Set to Date.now() at publish time.',
  stability: 'stable',
  deprecated: false,
  example: { restored: 8, failed: 0, skipped: 2, noData: 3, durationMs: 640, source: 'cloud' },
};
